/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_QInputs */

const vi_shop_home_link_q = /** @type {(inputs: Shop_Home_Link_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ khoá`)
};

/**

* @param {Shop_Home_Link_QInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_q = /** @type {((inputs?: Shop_Home_Link_QInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_QInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_q(inputs)
});